module.exports = __webpack_public_path__ + "img/622.923afd81.jpg";